<template>
  <div>
      <UploadImageForm v-if="$store.state.module.id"></UploadImageForm>  
  </div>
</template>

<script>
import UploadImageForm from "@/components/UploadImageForm.vue";

export default {
    components : {UploadImageForm},
  data() {
    return {
    };
  },
  methods : {
  }
};
</script>

<style lang="scss" scoped>
</style>